companyLocation:
  headOffice:
    title: Head Office
  create: Create an office
  noPeopleAssigned: Nobody is assigned to this office.
  delete: Delete this office
  createUser: Create a new user in this office
  address:
    edit: Edit Address
    updated: Address updated
  userCount_one: There is 1 user 
  userCount_other: There are {{ count }} users
  yachtCount_one: and 1 yacht assigned to this office.
  yachtCount_other: and {{ count }} yachts assigned to this office.
  chooseOfficeToMigrateTo: Choose another office to migrate them to.
admin:
  searchCompanies: Search Companies & Users
update:
  title: Update Company Details
legalNameHelperText: The name used on billing documents, if different from Name.
vatNumberHelperText: Added to invoices sent to you by Charter Index Ltd.
brokerFilter: Broker filter
